import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import './App.css';

import Menu from './Menu';
import Footer from './Footer.js';
import Chatbot from './Chatbot.js';

import mysticPic from './priest.png';
import TorahTrivia from './TorahTrivia.js';
import TorahTools from './TorahTools';
import TorahCode from './TorahCode.js';
import Game from './Game.js';
import Shop from './Shop.js';
import TorahPuzzle from './TorahPuzzle.js';

function Home() {
  return (
    <div className="home">
      <section className="heroCard">
        <div className="heroLeft">
          <h1 className="heroTitle">Highpriest</h1>
          <p className="heroSubtitle">
            My name is Aaron. Click the <b>Blessing</b> button to receive today’s blessing.
          </p>

          <div className="heroChatbot">
            <Chatbot />
          </div>
        </div>

        <div className="heroRight">
          <img src={mysticPic} alt="Mystic" className="heroImage" />
        </div>
      </section>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <Menu />
        </header>

        <main className="mainArea">
          <div className="mainInner">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/torah-tools" element={<TorahTools />} />
              <Route path="/TorahCode" element={<TorahCode />} />
              <Route path="/Game" element={<Game />} />
              <Route path="/Shop" element={<Shop />} />
              <Route path="*" element={<Navigate to="/" replace />} />
              <Route path="/TorahTrivia" element={<TorahTrivia />} />
              <Route path="/TorahPuzzle" element={<TorahPuzzle />} />
          
            </Routes>
          </div>
        </main>

        <Footer />
      </div>
    </Router>
  );
}